import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText, Icon } from '@paypalcorp/pp-react';
import fetch from 'isomorphic-fetch';
import WrappedLink from './WrappedLink';
import CategoryCard from './CategoryCard';
import CategoryToolTile from './CategoryToolTile';

import { AMPLITUDE } from '../../../lib/constants';

const {
  MAIN_APP_TILE_CLICK,
  MAIN_CATEGORY_VIEWALL_CLICK,
  MAIN_CATEGORY_TILE_CLICK
} = AMPLITUDE;

const CategoryRow = props => {
  const {
    content = {},
    featured = [],
    viewAllText = '',
    showAllText = '',
    fptiClick,
    fptiImpression,
    toolTileProps,
    isColoredIconsEligible
  } = props;
  const isNewLayoutEligible = toolTileProps?.flatPSData?.isNewLayoutEligible;
  const directionality = toolTileProps?.app?.context?.locale?.directionality;
  const handleClickCategory = fptiLink => {
    // fpti link is either the category/section OR 'viewall'
    // if 'viewall': pass 'viewall to handleClickCategory'

    const eventName =
      fptiLink === 'viewall'
        ? MAIN_CATEGORY_VIEWALL_CLICK
        : MAIN_CATEGORY_TILE_CLICK;

    fptiClick({
      fptiLink:
        (typeof fptiLink === 'string' && fptiLink) || content.categoryFPTI,
      category: 'parent',
      pageLink: content.categoryFPTI,
      amplitude: true,
      event_name: eventName
    });
    fetch(content.PSClickUrl);
  };

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: content.categoryFPTI,
        categoryRank,
        appKey,
        rank,
        priorityScore,
        amplitude: true,
        event_name: MAIN_APP_TILE_CLICK
      });
      fetch(PSUrl);
    };
  };

  const getCategoryLayout = () => {
    if (isNewLayoutEligible) {
      return featured.length < 4 ? ' category-grid singleton' : 'category-grid';
    }
    return 'category-row';
  };

  const chevronIcon =
    directionality === 'rtl' ? 'chevron-left' : 'chevron-right';
  return (
    <div
      className={
        isNewLayoutEligible ? 'appcenter-category new' : 'appcenter-category'
      }
    >
      <div
        className={
          isNewLayoutEligible ? 'category-header new' : 'category-header'
        }
      >
        <HeadingText level={2} >{content.categoryTitle}</HeadingText>
        <div>
          <WrappedLink
            onClick={() => handleClickCategory('viewall')}
            to={`/appcenter/${content.location}`}
          >
            {isNewLayoutEligible ? showAllText : viewAllText}
            {!isNewLayoutEligible && <Icon size="sm" name={chevronIcon} />}
          </WrappedLink>
        </div>
      </div>
      <div className={getCategoryLayout()}>
        {!isNewLayoutEligible && (
          <CategoryCard
            content={content}
            handleClick={handleClickCategory}
            fptiImpression={fptiImpression}
            isColoredIconsEligible={isColoredIconsEligible}
          />
        )}
        {featured.map((tool, index) => (
          <CategoryToolTile
            key={`category-row-tool-${index}`}
            handleClickTool={handleClickTool}
            tool={tool}
            path={`/appcenter/${content.location}`}
            fptiImpression={fptiImpression}
            toolTileProps={toolTileProps}
          />
        ))}
      </div>
    </div>
  );
};

CategoryRow.propTypes = {
  featured: PropTypes.array,
  content: PropTypes.object,
  fptiClick: PropTypes.func,
  viewAllText: PropTypes.string,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object,
  app: PropTypes.object,
  isColoredIconsEligible: PropTypes.bool,
  showAllText: PropTypes.string
};

export default CategoryRow;
